'use client';

import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';
import RetryErrorButton from '@/components/retry-error-button';
import ErrorContent from './(error-pages)/error-content';
interface Props {
  error?: Error;
  reset: () => void;
}
function ErrorPage({
  error
}: Props) {
  useEffect(() => {
    // Log the error to Sentry
    captureException(error);
  }, [error]);
  return <>
            <ErrorContent statusCode='default' data-sentry-element="ErrorContent" data-sentry-source-file="error.tsx" />
            <div className='fixed bottom-0 left-0 w-full p-4 lg:bottom-11 lg:left-1/2 lg:w-[344px] lg:-translate-x-1/2 lg:p-0'>
                <RetryErrorButton data-sentry-element="RetryErrorButton" data-sentry-source-file="error.tsx" />
            </div>
        </>;
}
export default ErrorPage;